import { LinkButton } from "./link-button";
import { FormButton } from "./form-button";
import { Ajax } from "../ajax";
export class Table {
    constructor() {
        this.table = $("#datatable");
        this.defs = [];
        this.lastValueSent = {};
        if (this.table.length == 0) {
            return;
        }
        const dataTable = this.table.DataTable({
            processing: false,
            serverSide: true,
            ajax: this.table.data("ajaxUrl"),
            deferLoading: this.table.data("recordsTotal"),
            columns: this.columns,
            data,
            columnDefs: this.defs,
            searching: true,
            ordering: false,
        });
        this.table.on("preXhr.dt", () => {
            Ajax.loading = true;
        });
        this.table.on("xhr.dt", () => {
            Ajax.loading = false;
        });
        dataTable
            .columns()
            .eq(0)
            .each((index, item) => {
            const column = dataTable.column(item);
            const input = $(column.footer()).find(":input");
            if (input.data("type") == "checkbox") {
                input.prop("indeterminate", true);
            }
            input.on("keyup change", (e) => {
                e.preventDefault();
                const { currentTarget } = e;
                const value = this.doColumnSearch(column, currentTarget);
                this.updateHiddenFiltersValues(currentTarget, value);
            });
        });
    }
    updateHiddenFiltersValues(currentTarget, value) {
        document
            .querySelectorAll(`.js-filter-${$(currentTarget).prop("name")}`)
            .forEach((el) => {
            el.value = value;
        });
    }
    doColumnSearch(column, input) {
        const columIndex = column.index();
        let value = $(input).val();
        switch ($(input).data("type")) {
            case "checkbox":
                value = $(input).prop("checked") ? "1" : "0";
                break;
            case "date":
                if (!value) {
                    break;
                }
                value = value.split("-");
                value = `${value[2]}-${value[1]}-${value[0]}`;
        }
        if (columIndex in this.lastValueSent &&
            this.lastValueSent[columIndex] === value) {
            return value;
        }
        if (this.timeoutHandler !== undefined) {
            window.clearTimeout(this.timeoutHandler);
        }
        this.lastValueSent[columIndex] = value;
        this.timeoutHandler = window.setTimeout(function () {
            column.search(value).draw();
        }.bind(this), 1000);
        return value;
    }
    hasActionColumn() {
        return rowButtons.length > 0;
    }
    get columns() {
        if (this._columns === undefined) {
            this._columns = [];
            this.table.find("thead th").each((i, item) => {
                const name = $(item).data("name");
                if (name) {
                    this._columns.push({
                        name,
                        data: name,
                        searchable: true,
                        render: (data, type, row) => {
                            // We create a link if the data is an object with an url property. Else we return the data as is.
                            if (typeof data === "object" && data.url) {
                                return `<a href="${data.url}">${data.value}</a>`;
                            }
                            return data;
                        },
                    });
                    this.defs.push({ targets: i, visible: true, searchable: true });
                }
            });
            this.addActionColumns();
        }
        return this._columns;
    }
    addActionColumns() {
        if (!this.hasActionColumn()) {
            return;
        }
        this._columns.push({
            render: (data, type, row) => {
                const buttons = $("<div>");
                rowButtons.forEach((button) => {
                    this.createButton(button, row).appendTo(buttons);
                });
                return `<div class="buttons">${buttons.html()}</div>`;
            },
        });
    }
    createButton(buttonData, row) {
        if (buttonData.method === undefined || buttonData.method === "GET") {
            return new LinkButton(buttonData, row);
        }
        else if (buttonData.method === "POST") {
            return new FormButton(buttonData, row);
        }
    }
}
